import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import { Guid } from "guid-typescript";
import { AuthService } from "../Services/auth.service";
import { CommonService } from "../Services/common.service";
import { CountriesService, Country } from "../Services/countries.service";
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { list } from "../SharedComponents/drop-down-list/drop-down-list.component";
import { ConfigService } from "../Services/config.service";
import * as APIURL from "../../assets/APIURL.json";
import { debug } from "console";

declare var window;
@Component({
  selector: "app-mobile-verification",
  templateUrl: "./mobile-verification.component.html",
  styleUrls: ["./mobile-verification.component.scss"],
})
export class MobileVerificationComponent implements OnInit {
  uniqueId: Guid;

  id;
  mobileform: FormGroup;
  mobilemaxlength: number;
  mobileminlength: number;
  mobilenumber: string;
  selected = null;
  numberPlaceHolder: string = "XXX-XXXXXXX";

  selectedMobile: Country;
  mask: string = "";
  _number: string = "";
  dropdownlist: list[] = [];
  accountType: string = "";
  mobilelist;
  mobilelistrender: boolean = false;
  maxNumber: number = 0;
  selectedCountryIcon: string = "icon-pakistan";
  selectedCurrentCountry: string = "+92";
  selectedDropNumber: string = "";
  selectedIcon: string;
  max;
  siteKey: string;
  stepListData;
  recaptchaSwitch: boolean = true;
  constructor(
    private config: ConfigService,
    private countriesP: CountriesService,
    private fb: FormBuilder,
    private commonP: CommonService,
    public errorkey: ErrorMessageKeyService,
    public translate: TranslateService,
    public authP: AuthService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    debugger;

    this.mobileform = this.fb.group({
      mobile: [
        "",
        Validators.compose([
          Validators.minLength(this.mobileminlength),
          Validators.maxLength(this.mobilemaxlength),
          Validators.required,
          Validators.pattern("[0-9]*"),
        ]),
      ],
      recaptcha: [""],
    });
    let recaptcha = this.mobileform.controls["recaptcha"];
    debugger;
    if (APIURL.Switch) {
      this.recaptchaSwitch = true;
      recaptcha.markAsUntouched();
      recaptcha.setValidators(Validators.compose([Validators.required]));
      recaptcha.updateValueAndValidity();
    } else {
      this.recaptchaSwitch = false;
      recaptcha.clearValidators();
      recaptcha.reset();
    }
    this.commonP.delete("User");
    this.commonP.delete("token");
    this.commonP.delete("productId");
    this.commonP.delete("idcardexpire");
    this.commonP.clear();
    this.showPopup();
    this.commonP.hideLoading();
  }

  async ngOnInit() {
    let aaaaa: any = await this.authP.GetFromJson();
    console.log("Resposne from FIle", aaaaa.sitekey);
    this.siteKey = aaaaa.sitekey;


    this.route.queryParams.subscribe(params => {
      debugger;

      if (params.accountType) {
        debugger;

        this.accountType = params.accountType;

        if (this.accountType) {

          this.authP.AllUserDetials.accountType = this.accountType;
          this.commonP.Set("accountType", this.accountType);

          if (this.accountType == "M") {

            this.commonP.Set("productId", "60");

          }
        }
        console.log('accountType', this.accountType);

      }

      this.commonP.Set("accountType", this.accountType);



    })

  }

  Signupfunc() {
    this.commonP.clear();
  }

  async showPopup() {
    this.uniqueId = Guid.create();
    this.id = this.uniqueId.toString();

    console.log(this.id, "this.id");
    this.commonP.presentLoading();
    debugger;
    await this.countriesP.GetAllowedMobile(this.id).then((data: any) => {
      if (data?.response?.code == 1) {
        this.mobilelist = data.response.content.filter(
          (x) => x.isMobile == true
        );
        debugger;
        this.mobilelist?.sort((a, b) =>
          a.mobileCode.localeCompare(b.mobileCode)
        );
        console.log("this.mobilelist", this.mobilelist);

        this.mobilelistrender = true;
        this.selectedIcon =
          "assets/svg-flags/" + this.mobilelist[0].flagClass + ".svg";
        console.log("this.selectedIcon", this.selectedIcon);

        this.selectedDropNumber = this.mobilelist[0].mobileCode;
        console.log("this.selectedDropNumber", this.selectedDropNumber);

        this.mobileminlength = this.mobilelist[0].mobileLength - 1;
        console.log("minmobile", this.mobileminlength);

        this.mobileminlength = this.mobilelist[0].mask
          ? this.mobilelist[0].mask
          : new Array(this.maxNumber).join("9");

        this.numberPlaceHolder = this.mobilelist[0].mask
          ? this.mobilelist[0].mask.replace(/9/g, "X")
          : new Array(this.mobileminlength).join("X");
        this.mobilemaxlength = 11;

        this.dropdownlist = this.mobilelist.map((x) => ({
          value: x,
          displayValue: x.mobileCode,
          iconClass: x.flagClass,
        }));
        let con = this.mobileform.controls["mobile"];
        debugger;
        con.clearValidators();
        con.setValidators(
          Validators.compose([
            Validators.minLength(this.mobileminlength),
            Validators.maxLength(this.mobilemaxlength),
            Validators.required,
            Validators.pattern("[0-9]*"),
          ])
        );
        this.commonP.hideLoading();
      } else {
        this.commonP.hideLoading();
        //this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  IsFormValid() {


    if (
      this.mobileform.valid &&
      (this.mobilenumber.length == this.mobilelist[0]?.mobileLength ||
        this.mobilenumber.length > this.mobilelist[0]?.mobileLength)
    ) {
      if (this.mobilenumber.length > 10) {
        this.max = true;
        return true;
      } else {
        this.max = false;
        return false;
      }
    } else {
      this.max = false;
      return true;
    }
  }

  onCountryChange(event) {
    console.log(event);
    this.selectedCountryIcon = event.iconClass;
    this.selectedCurrentCountry = event.displayValue;
    this.mobilemaxlength = event.value.mobileMaxLength;
    this.mobileminlength = event.value.mobileLength - 1;
    let con = this.mobileform.controls["mobile"];
    con.clearValidators();
    con.setValidators(
      Validators.compose([
        Validators.minLength(this.mobileminlength),
        Validators.maxLength(this.mobilemaxlength),
        Validators.required,
        Validators.pattern("[0-9]*"),
      ])
    );
  }
  onCaptchaResponse(e) {
    debugger;
    console.log(e);
    this.mobileform.get("recaptcha").setValue(e);
  }
  onCaptchaExpired() {
    this.mobileform.get("recaptcha").setValue("");
  }
  VerifyMobilebNumber() {
    var RecaptchaToken;

    RecaptchaToken = this.mobileform.get("recaptcha").value;

    //console.log("Captch Token", RecaptchaToken);
    this.uniqueId = Guid.create();
    this.id = this.uniqueId.toString();
    this.countriesP.IOSCode = this.selectedCurrentCountry;
    this.countriesP.mobileNumber = this.mobilenumber;
    let fullmobile =
      this.selectedCurrentCountry?.replace("+", "") + "" + this.mobilenumber;

    //  this.commonP.Set('mobilenumber', fullmobile);
    console.log(this.id, "this.id");
    this.commonP.presentLoading();
    this.authP
      .checkMobileNumber(fullmobile, RecaptchaToken, this.id)
      .then(async (data: any) => {
        console.log(data, "Checkmobileapi");
        debugger;
        if (data?.response?.code == 1) {
          this._router.navigateByUrl("/mobileOTP");
          this.commonP.Set("mobilenumber", fullmobile);
          this.commonP.hideLoading();
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  getMessage(key, control) {
    let error = "";
    this.translate.get([key]).subscribe((data) => {
      error = data[key];
    });
    return error;
  }

  Enterkey(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      let valid = this.IsFormValid();
      debugger;
      if (valid == false) {
        // this.VerifyMobilebNumber();
      }
    }
  }

  /* WIDTH = 640;
   HEIGHT = 480;
 
   @ViewChild("video")
   public video: ElementRef;
 
   @ViewChild("canvas")
   public canvas: ElementRef;
 
   captures: string[] = [];
   error: any;
   isCaptured: boolean;
 
   async ngAfterViewInit() {
     await this.setupDevices();
   }
 
   async setupDevices() {
     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
       try {
         const stream = await navigator.mediaDevices.getUserMedia({
           video: true
         });
         if (stream) {
           this.video.nativeElement.srcObject = stream;
           this.video.nativeElement.play();
           this.error = null;
         } else {
           this.error = "You have no output video device";
         }
       } catch (e) {
         this.error = e;
       }
     }
   }
 
   capture() {
     this.drawImageToCanvas(this.video.nativeElement);
     //console.log(this.canvas.nativeElement.toDataURL("image/png"), "dkfnddf")
     this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
     console.log(this.captures, "dkfnddf")
     this.isCaptured = true;
     debugger
     var base64 = this.canvas.nativeElement.toDataURL("image/png").split(',');
     console.log(base64[1])
   }
 
   removeCurrent() {
     this.isCaptured = false;
   }
 
   setPhoto(idx: number) {
     this.isCaptured = true;
     var image = new Image();
     console.log(image, "dvnhdv")
     image.src = this.captures[idx];
     this.drawImageToCanvas(image);
   }
 
   drawImageToCanvas(image: any) {
     this.canvas.nativeElement
       .getContext("2d")
       .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
   }*/

  checked() {

  }

  // Shayan changes As Per BRD 04-10-2024

  labelLink(e) {
    e.preventDefault();
    window.open("assets/Declaration_of_resident_pakistani.pdf", "_blank");
  }
  labelLink1(e) {
    e.preventDefault();
    window.open("assets/Digital-Account-Opening-Consent.pdf", "_blank");

  }

  // Shayan changes As Per BRD 04-10-2024
}
